/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const FilterDtoStatusEnum = {
    Published: 'Published',
    Draft: 'Draft',
    Archived: 'Archived',
    PendingReview: 'Pending Review'
};
/**
 * Check if a given object implements the FilterDto interface.
 */
export function instanceOfFilterDto(value) {
    if (!('isCrate' in value) || value['isCrate'] === undefined)
        return false;
    return true;
}
export function FilterDtoFromJSON(json) {
    return FilterDtoFromJSONTyped(json, false);
}
export function FilterDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'] == null ? undefined : json['name'],
        'status': json['status'] == null ? undefined : json['status'],
        'minTrackCount': json['minTrackCount'] == null ? undefined : json['minTrackCount'],
        'maxTrackCount': json['maxTrackCount'] == null ? undefined : json['maxTrackCount'],
        'minViewCount': json['minViewCount'] == null ? undefined : json['minViewCount'],
        'maxViewCount': json['maxViewCount'] == null ? undefined : json['maxViewCount'],
        'minSaveCount': json['minSaveCount'] == null ? undefined : json['minSaveCount'],
        'maxSaveCount': json['maxSaveCount'] == null ? undefined : json['maxSaveCount'],
        'minCrateCount': json['minCrateCount'] == null ? undefined : json['minCrateCount'],
        'maxCrateCount': json['maxCrateCount'] == null ? undefined : json['maxCrateCount'],
        'minSubfolderCount': json['minSubfolderCount'] == null ? undefined : json['minSubfolderCount'],
        'maxSubfolderCount': json['maxSubfolderCount'] == null ? undefined : json['maxSubfolderCount'],
        'createdStartDate': json['CreatedStartDate'] == null ? undefined : json['CreatedStartDate'],
        'createdEndDate': json['CreatedEndDate'] == null ? undefined : json['CreatedEndDate'],
        'lastModifiedStartDate': json['lastModifiedStartDate'] == null ? undefined : json['lastModifiedStartDate'],
        'lastModifiedEndDate': json['lastModifiedEndDate'] == null ? undefined : json['lastModifiedEndDate'],
        'isCrate': json['isCrate'],
    };
}
export function FilterDtoToJSON(json) {
    return FilterDtoToJSONTyped(json, false);
}
export function FilterDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'status': value['status'],
        'minTrackCount': value['minTrackCount'],
        'maxTrackCount': value['maxTrackCount'],
        'minViewCount': value['minViewCount'],
        'maxViewCount': value['maxViewCount'],
        'minSaveCount': value['minSaveCount'],
        'maxSaveCount': value['maxSaveCount'],
        'minCrateCount': value['minCrateCount'],
        'maxCrateCount': value['maxCrateCount'],
        'minSubfolderCount': value['minSubfolderCount'],
        'maxSubfolderCount': value['maxSubfolderCount'],
        'CreatedStartDate': value['createdStartDate'],
        'CreatedEndDate': value['createdEndDate'],
        'lastModifiedStartDate': value['lastModifiedStartDate'],
        'lastModifiedEndDate': value['lastModifiedEndDate'],
        'isCrate': value['isCrate'],
    };
}
